import { Component } from '@angular/core';

@Component({
  selector: 'lib-mini-loader',
  templateUrl: './mini-loader.component.html',
  styleUrls: ['./mini-loader.component.scss'],
})
export class MiniLoaderComponent {}
